module.exports = __webpack_public_path__ + "img/目錄icon.3cd6bb97.svg";